import type { GameConfig, GameFeatures } from './types';

/**
 * Default game configuration
 *
 * Uses mobile-friendly defaults:
 * - 720x1080 internal resolution (good for both mobile and desktop)
 * - FIT scale mode to maintain aspect ratio
 * - Auto-center in parent container
 */
export const DEFAULT_CONFIG: GameConfig = {
  width: 720,
  height: 1080,
  backgroundColor: '#000000',
  parent: 'game-container',
  debug: false,
  scaleMode: 'fit',
  minWidth: 320,
  minHeight: 480,
  autoCenter: true,
};

/**
 * Default feature flags (all disabled)
 */
export const DEFAULT_FEATURES: GameFeatures = {
  splash: false,
  preloader: false,
  highscore: false,
  raffle: false,
  api: false,
  analytics: false,
};
